//
// X-Correlation-Id da wi-nfse-api.
//
// A API exige o header em TODAS as rotas /v1/nfse/** e responde
// 400 CORRELATION_ID_OBRIGATORIO sem ele. Nao serve qualquer string: tem
// que ser UUID v4.
//
// Mora aqui, e nao dentro do interceptor, pela mesma razao das regras de
// sessao: funcao pura da para testar sem subir axios.
//
// crypto.randomUUID so existe em contexto seguro - https e localhost, que
// e exatamente onde o portal roda (producao e o dev server). O fallback com
// getRandomValues cobre navegador antigo, e o ultimo caso usa Math.random:
// entropia pior, mas o header serve para correlacionar log, nao para
// proteger nada.
//

function formatar (bytes) {
  const hex = []
  for (let i = 0; i < 16; i++) {
    hex.push((bytes[i] + 0x100).toString(16).slice(1))
  }
  return hex.slice(0, 4).join('') + '-' +
         hex.slice(4, 6).join('') + '-' +
         hex.slice(6, 8).join('') + '-' +
         hex.slice(8, 10).join('') + '-' +
         hex.slice(10, 16).join('')
}

/** Marca os bits de versao (4) e variante (RFC 4122) exigidos pelo UUID v4. */
function carimbar (bytes) {
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  return bytes
}

export function novoCorrelationId () {
  try {
    if (typeof crypto !== 'undefined') {
      if (typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID()
      }
      if (typeof crypto.getRandomValues === 'function') {
        return formatar(carimbar(crypto.getRandomValues(new Uint8Array(16))))
      }
    }
  } catch (e) {
    // crypto indisponivel ou bloqueado - cai no Math.random abaixo.
  }

  const bytes = new Uint8Array(16)
  for (let i = 0; i < 16; i++) {
    bytes[i] = Math.floor(Math.random() * 256)
  }
  return formatar(carimbar(bytes))
}
